// outer
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

// features
import { toastLogic } from '@_features/auth';

export function useLoginErrorHandle() {
	const [searchParams, setSearchParams] = useSearchParams();

	useEffect(() => {
		const errorType = searchParams.get('error_type');
		const errorMessage = searchParams.get('message');

		if (errorType !== null) {
			toastLogic.toastLoginErrorMessage(errorType, errorMessage);
			setSearchParams('');
		}
	}, []);
}
